import Http from "./http";

export const getTermsAndConditionsListAPI = (payload) => {
  return Http.post("admin/campaign/terms-condition/list", payload);
};

